/**
 * Mulberry32 PRNG
 * Read more at: https://github.com/bryc/code/blob/master/jshash/PRNGs.md#mulberry32-and-splitmix32
 */
/* eslint-disable */
function mulberry32(a) {
  return function () {
    a |= 0;
    a = a + 0x6D2B79F5 | 0;
    let t = Math.imul(a ^ a >>> 15, 1 | a);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}

export { mulberry32 as m };
//# sourceMappingURL=mulberry32-DfbDYDTB-DfbDYDTB.js.map
